import React from 'react';

import { FilterBar } from 'src/common/components/filter-bar';
import { DashboardInsightsTabType, DashboardInsightsTabTypes } from 'src/dashboard/insights/constants';
import { DashboardAnalyticsJourneysAll } from 'src/comprehensive-analytics/journeys';

import useDashboardActiveTab from 'src/dashboard/helpers/active-tab.hook';
import { Helmet } from 'react-helmet';
import { useCurrentSubscription } from 'src/store/subscription';
import { FixedLoadingSpinner } from 'src/common/components/loading-spinner';
import OrganizationLink from 'src/common/OrganizationLink';

function getFilterBarPlaceholder(activeTab: DashboardInsightsTabType) {
  switch (activeTab) {
    case 'content':
      return 'Search content';
    case 'journeys':
      return 'Search journeys';
    case 'visitors':
      return 'Search visitors';
    case 'synced-steps':
      return 'Search synced steps';
  }
}

type DashboardInsightsPropsInterface = {
  activeListType: string;
};

export const AnalyticsOverview = ({ activeListType }: DashboardInsightsPropsInterface) => {
    useDashboardActiveTab('analytics');

  const {  subscriptionLoading, isSubscribed, isOnTrial, isPro, isEnterprise } = useCurrentSubscription();

  const activeTab = DashboardInsightsTabTypes.includes(activeListType as DashboardInsightsTabType)
    ? (activeListType as DashboardInsightsTabType)
    : 'content';

  return (
    <>
     <Helmet>
        <title>
          Journey | Analytics Overview
        </title>
      </Helmet>
      <div className='flex flex-col w-full'>
        <div className='text-bedrock-serif-h1'>Analytics</div>

        {
          subscriptionLoading? 
          <FixedLoadingSpinner/>
          :
          (
              (!isSubscribed && !isOnTrial) || (isSubscribed && !isEnterprise)?
              <div className='mt-10'>
              <span className='text-neue-journey-medium mb-5'>Upgrade to Scale Plan to access comprehensive analytics</span>
              <img className="mt-3 rounded-md border border-gray-800" src={"https://dashboardcdn.journey.io/dashboard-images/comp-analytics-preview.png"} width={466} height={458} alt={'Comprehensive-Analytics'} />
              <div className='mt-4'>
              <OrganizationLink
               to={`/billing`}
                className='btn-bedrock-primary'
              >
                Upgrade to Scale Plan
              </OrganizationLink>
            </div>
              </div>
            :
            <>
             <div className='mt-6 flex space-x-md divide-x divide-bedrock-gray-medium'>
          <FilterBar searchPlaceholder={getFilterBarPlaceholder(activeTab)} widthClassname='w-[150px]' />
        </div>
        <div className='flex flex-col mt-6'>
            <DashboardAnalyticsJourneysAll />
        </div>
            
            </>
          )

            }

       
      </div>
    </>
  );
};
